module.exports = __webpack_public_path__ + "media/images/games/35gender/doll-ffbcc85075db8e44318ddbd8fdfc6b83.png";